/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prefer-es6-class */
import React from 'react';
import * as pt from 'prop-types';
import createReactClass from 'create-react-class';
import update from 'react-addons-update';
import Select from 'react-select';
// require('react-select/dist/react-select.css');

import Modal from '../../../../common/components/Modal';

var CreateCategoryModal = createReactClass({

    getInitialState: function () {
        return {
            newCategory: {
                categoryName: '',
                displayName: null,
                categoryDescription: '',
                parentCategoryID: null,
                duplicated: false
            }
        };
    },

    handleParentCategoryChange: function (value) {
        var updates = {};
        updates['parentCategoryID'] = {$set: value};
        this.setState({
            newCategory: update(this.state.newCategory, updates)
        });
    },
    componentDidUpdate: function() {
        const duplicatedCategory = this.isDuplicate()
        if (duplicatedCategory && !this.state.duplicated) {
            this.setState({duplicated: true})
        } else if (!duplicatedCategory && this.state.duplicated) {
            this.setState({duplicated: false})
        }
    },

    handleChange: function (event) {
        var updates = {};
        updates[event.target.name] = {$set: event.target.value};
        this.setState({
            newCategory: update(this.state.newCategory, updates)
        });
    },
    isDuplicate: function() {
        const newCategory = this.state.newCategory
        const categories = this.props.categories
        function hasSameName (catName) {
            // has the same displayName or categoryName of an existing category
            // case insensitve with leading and trailing spaces removed
            function insensitive(cat) {
                return cat.trim().toLowerCase()
            }
            const categoryName = insensitive(catName)
            const newDisplayName = insensitive(newCategory.displayName || newCategory.categoryName)
            const newCategoryName = insensitive(newCategory.categoryName)
            return categoryName === newCategoryName || categoryName === newDisplayName
        }
        if (categories.some(cat => hasSameName(cat.label))) {
            return true
        }
        return false
    },

    handleSave: function () {
        if (this.isDuplicate()) {
            this.setState({duplicated: true})
            return false
        } else {
            return this.props.save(this.state.newCategory)
        }
    },

    render: function () {

        if (this.props.createModal) {
            return (<Modal
                cancelModal={this.props.toggleCreateModal}
                saveAction={<button className="btn btn-success" onClick={this.handleSave}>
                    <i className="fa fa-save"/> Create
                </button>}>
                <Modal.Header>Create Category</Modal.Header>

                <Modal.Body>

                    <label>Category Name</label>
                    <input className="form-control"
                        name="categoryName"
                        onChange={this.handleChange}
                        value={this.state.newCategory.categoryName}
                        placeholder="Required"
                    />

                    <div style={{margin: '2rem 0'}}/>

                    <label>Display Name</label>
                    <input className="form-control"
                        name="displayName"
                        onChange={this.handleChange}
                        value={this.state.newCategory.displayName}
                        placeholder="(optional) Public friendly name"
                    />

                    <div style={{margin: '2rem 0'}}/>

                    <label>Parent Category</label>
                    <Select
                        name="Categories"
                        value={this.state.newCategory.parentCategoryID || ''}
                        options={this.props.categories}
                        onChange={this.handleParentCategoryChange}
                    />

                    <div style={{margin: '2rem 0'}}/>

                    <label>Category Description</label>
                    <textarea className="form-control"
                        name="categoryDescription"
                        onChange={this.handleChange}
                        value={this.state.newCategory.categoryDescription}
                    />
                </Modal.Body>

                <Modal.Footer >
                    {this.state.duplicated ? <div>This category name or display name is already in use.</div> : null}
                </Modal.Footer>
            </Modal>);
        }
    }
});

export default CreateCategoryModal;
